import { useEffect } from 'react';
import ConfirmDialog from './confirm-dialog';
import { useModalManager } from '@/components/global/modal-manager/store';
import { useModalBackButton } from '@/ui/kit/utils/modal-back-button';
const ModalManager = () => {
  const {
    title,
    isOpen,
    setOpen,
    closeModal,
    data,
    children,
    action
  } = useModalManager();
  useModalBackButton({
    open: isOpen,
    onClose: () => setOpen(false)
  });
  useEffect(() => {
    window.addEventListener('popstate', closeModal);
    return () => {
      window.removeEventListener('popstate', closeModal);
    };
  }, [closeModal]);
  return <ConfirmDialog maxWidth={data?.width} content={children} hasCancel={data?.hasCancel} open={isOpen} title={title} onClose={closeModal} action={action} bgColor={data?.bgColor} noPadding={data?.noPadding} data-sentry-element="ConfirmDialog" data-sentry-component="ModalManager" data-sentry-source-file="index.tsx" />;
};
export default ModalManager;